export default [
  {
    path: '/reports/guardian-account-statement',
    name: 'reports.guardianAccountStatement',
    component: () => import('@/views/reports/GuardianAccountStatementReport.vue'),
    meta: {
      title: 'accountStatements.guardian_title',
      requiresAuth: true,
      requiredPerm: 'payment_receipts.display'
    }
  },
  {
    path: '/reports/guardian-wallet-statement',
    name: 'reports.guardianWalletStatement',
    component: () => import('@/views/reports/GuardianWalletStatementReport.vue'),
    meta: {
      title: 'accountStatements.guardian_wallet_title',
      requiresAuth: true,
      requiredPerm: 'payment_receipts.display'
    }
  },
  {
    path: '/reports/student-account-statement',
    name: 'reports.studentAccountStatement',
    component: () => import('@/views/reports/StudentAccountStatementReport.vue'),
    meta: {
      title: 'accountStatements.student_title',
      requiresAuth: true,
      requiredPerm: 'payment_receipts.display'
    }
  },
  {
    path: '/reports/student-wallet-statement',
    name: 'reports.studentWalletStatement',
    component: () => import('@/views/reports/StudentWalletStatementReport.vue'),
    meta: {
      title: 'accountStatements.student_wallet_title',
      requiresAuth: true,
      requiredPerm: 'payment_receipts.display'
    }
  }
];
